export const Config = {
  basePath: 'http://api.scopolamine.noi.top',
  // basePath: 'http://127.0.0.1:5010',
  version: '1.8.0',
};
